<div style="position: relative;">
  <image-cropper style="max-height: calc(80vh - 150px); width: calc(80vw - 50px);" [imageFile]="cropInput"
    [maintainAspectRatio]="false" [canvasRotation]="canvasRotation" [transform]="transform" output="blob" format="jpeg"
    (imageCropped)="imageCropped($event)"></image-cropper>

  <div style="display: flex; margin-top: .5rem;">
    <div style="flex-grow: 1;" class="flex flex-row gap-3">
      <p-button (click)="rotateLeft()" title="Rotate Left" icon="pi pi-replay"></p-button>
      <p-button (click)="rotateRight()" title="Rotate Right" icon="pi pi-refresh"></p-button>
      <p-button (click)="flipHorizontal()" title="Flip Horizontal" icon="pi pi-arrows-h"></p-button>
      <p-button (click)="flipVertical()" title="Filp Vertical" icon="pi pi-arrows-v"></p-button>
    </div>
    <div class="flex flex-row gap-3">
      <p-button type="button" class="p-button-raised" (click)="cropOk()">Ok</p-button>
      <p-button type="button" class="p-button-raised" (click)="cropCancel()">Cancel</p-button>
    </div>
  </div>
</div>